export default __webpack_public_path__ + "static/media/Flag_of_Poland.0882b3e3.svg";